import { Button, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import { SET_MODAL_STATUS, SET_MODAL_TYPE } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const FreemiumQuestionCard = () => {
    const { companyCreator } = useSelector((state) => state.authentication);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onClickHandler = () => {
        navigate('/dashboard/update-plan');
    };

    const onClick = () => {
        if (!companyCreator) {
            dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
            dispatch({ type: SET_MODAL_TYPE, modalType: 'non_permit_upgrade' });
            return;
        }
        onClickHandler();
    };
    return (
        <>
            <Stack gap="10px" className="freemium-question-card" alignItems="center" justifyContent="center">
                <Stack
                    alignItems="center"
                    sx={{
                        maxWidth: '296px'
                    }}
                >
                    <Typography
                        component="span"
                        sx={{
                            width: '24px',
                            height: '24px',
                            backgroundColor: '#FBB414',
                            borderRadius: '50%',
                            padding: '4px 3px',
                            svg: {
                                width: '18px',
                                height: '18px',
                                path: {
                                    fill: '#fff'
                                }
                            }
                        }}
                        mb="12px"
                    >
                        <DiamondOutlinedIcon />
                    </Typography>
                    <Stack mb={2}>
                        <Typography variant="subtitle1" component="p" color="#7D7D82" fontSize="1rem" lineHeight="1.2" fontWeight="500">
                            Not enough room for questions to add to your registry?
                        </Typography>
                        <Typography variant="subtitle1" component="p" color="#7D7D82" fontSize="1rem" lineHeight="1.2" fontWeight="500">
                            Upgrade for full access to the question registry.
                        </Typography>
                    </Stack>
                    <Button
                        className="alternate"
                        onClick={onClick}
                        sx={{
                            '&.alternate': {
                                color: '#ffffff',

                                '&:hover': {
                                    color: '#00214d',
                                    background: 'transparent'
                                }
                            }
                        }}
                    >
                        Upgrade
                    </Button>
                </Stack>
            </Stack>
        </>
    );
};

export default FreemiumQuestionCard;
